import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
// controls
import Table, { Column } from '../../table'
import {
  formatDatetime,
  getCategoryFilterType,
  useHandleExportReport,
  getMethodToFormatDuration
} from 'Modules/reports/views/main/components/reportsTab/helper';



import { useSidePanelMap, useTableReport } from 'Core/hooks';
import AddressLandmark from 'Modules/reports/views/main/components/reportsTab/.components/addressLandmark'


import {
  reportsMainGenerateEvents
} from 'Redux/actions'

const StopHistoryReport = (props) => {
  const { messages, report, user } = props;
  const { durationFormat } = user;
  const { loading, data, filters, events, summary, loadingSummary, subEvents, loadingSubEvents, timeZone } = report;
  const { filterEntity, filterArray, otherFilters, filterType, startRange, endRange } = filters;

  const [SideMapComponent, onToggleSideMap] = useSidePanelMap();

  const reportRef = useRef();
  const dispatch = useDispatch()
  const exportHandler = useHandleExportReport(report);



  useEffect(() =>{
    if(report){
      const newReport = JSON.parse(JSON.stringify(report));
      reportRef.current = newReport;
    }
  }, [JSON.stringify(report)]);

  const durationFormatTime = getMethodToFormatDuration(durationFormat);

  const onChangeExpandable = (unit) => {
    if(!unit.noData){
      let events = {
        data: [],
        filters: {
          filterType: getCategoryFilterType(filterEntity),
          filterArray: unit,
          page: 1,
          rowsPerPage: 10,
          sortField: 'eventDate',
          otherFilters
        }
      }
      dispatch(reportsMainGenerateEvents(report, events))
    }
  }

  let parametersSummary = useTableReport({data, report, messages, hideHeader: false});



  const renderExpandableRow = (row) => {
    let parametersSummaryTable = {
      ...parametersSummary,
      data: summary?.items || [],
      totalItems: summary?.total || 0,
      hideHeader: false,
      serverSideTable: true,
      onChangedPage: (page, rowsPerPage, sortField, sortOrder) => {
        let events = {
          data: [],
          filters: { filterType: getCategoryFilterType(filterEntity), filterArray: row, page, rowsPerPage, sortField, sortOrder, otherFilters }
        }
        dispatch(reportsMainGenerateEvents(report, events))
      },
      onChangeSelector: null,
      itemsSelector: null,
      generateExport: false,
      hideSelectorUnitsDriver: true,
      groups:report.filters.units || [],
      hideNumberOfRows:true,
      centerPagination: true,
      noData: row.noData
    };
    return (
      <Table
        {...parametersSummaryTable}
        loading={loadingSummary}
      >

        <Column label={messages['generatedReport_timeAndDate']} field="dateTime" noSorting>
          {(element) => {
            return (
              formatDatetime(element.dateTime, "MMMM D, YYYY h:mm A", timeZone)
            );
          }}
        </Column>
        <Column label={messages["generatedReport_address"]} field="address" noSorting>
            {(element) => {
              return (
                <AddressLandmark onToggleSideMap={onToggleSideMap} messages={messages} element={element}/>
              )
            }}
          </Column>
        <Column label={messages['generatedReport_title']} field="title" noSorting>
          {(element) => {
            return (
              element.title
            );
          }}
        </Column>
        <Column label={messages['generatedReport_status']} field="status" noSorting>
          {(element) => {
            return (
              element.status
            );
          }}
        </Column>
        <Column label={messages['generatedReport_tripDuration']} field="tripDuration" noSorting>
          {(element) => {
            return (
              element.tripDuration ? durationFormatTime(element.tripDuration, messages) : ' '
            );
          }}
        </Column>
      </Table>
    )
  }

  let parametersTable = useTableReport({
    data: data.items,
    report,
    messages,
    hideHeader: true,
    renderExpandableRow,
    onChangeExpandable,
    propertyToShowExpandable: 'id'
  });

  return (
    <Fragment>
      <Table
        {...parametersTable}
        {...exportHandler}
      >
        <Column label="Day" field="label">
          {(element) => {
            return (
              <div>
                <span>
                  <span><strong>{messages['generatedReport_driver']}:</strong> {element.driverName} </span>
                </span>
              </div>
            );
          }}
        </Column>
        <Column label={messages['generatedReport_totalIdleTime']} field="label">
          {(element) => {
            const localTimeStart = moment.utc(startRange).local().format();
            const localTimeEnd = moment.utc(endRange).local().format();
            return (
              <div>
                <span>
                  <span>
                    <strong>{messages['generatedReport_range']}:</strong> {` ${formatDatetime(localTimeStart, "MMMM D, YYYY h:mm A", timeZone)} - ${formatDatetime(localTimeEnd, "MMMM D, YYYY h:mm A", timeZone)}`}
                  </span>
                </span>
              </div>
            );
          }}
        </Column>
      </Table>
      <SideMapComponent hiddenButton hiddenSearchMap />
    </Fragment>
  );
}

export default StopHistoryReport
